var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { basicPoiFields } from '../../../model/Field';
import { fieldToNetworkField } from '../../../utils/field';
let NetworkFieldManager = class NetworkFieldManager extends LitElement {
    getNetworkFields() {
        const fieldManager = this.renderRoot.querySelector('field-manager');
        const matchColField = fieldManager.getFieldsMatch();
        const networkFields = [];
        const renameDict = {};
        Object.entries(matchColField).forEach(([colName, field]) => {
            renameDict[colName] = field.name;
            networkFields.push(fieldToNetworkField(field, networkFields.length));
        });
        return { renameDict, networkFields };
    }
    concatFields() {
        const fields = [...basicPoiFields];
        this.networkFields.forEach((nf) => {
            if (!fields.find((f) => f.name === nf.name)) {
                fields.push(nf);
            }
        });
        return fields;
    }
    render() {
        return html `<field-manager
      .dataFrame=${this.dataFrame}
      .fields=${this.concatFields()}
    ></field-manager>`;
    }
};
__decorate([
    property({ type: Object })
], NetworkFieldManager.prototype, "dataFrame", void 0);
__decorate([
    property({ type: Object })
], NetworkFieldManager.prototype, "networkFields", void 0);
NetworkFieldManager = __decorate([
    customElement('network-field-manager')
], NetworkFieldManager);
export { NetworkFieldManager };
//# sourceMappingURL=NetworkFieldManager.js.map